import { useQuery } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { IWorkerRate } from "../../interfaces/IWorkerRate";

export const useGetWorkerRate = (searchUri?: string) => {
    const {
        data: workerRareArray,
        isLoading: isLoadingWorkRate,
        refetch: refetechWorkerRate,
    } = useQuery<IWorkerRate[]>({
        queryKey: ["dashboard/worker_rate/", "search", searchUri],
        queryFn: () => customFetcher({ endpoint: `/dashboard/worker_rate/${searchUri ? `?${searchUri}` : ""}` }),
    });
    return { workerRareArray, isLoadingWorkRate, refetch: refetechWorkerRate };
};

export const useGetLeadSourceRate = () => {
    const {
        data: leadSourceRateArray,
        isLoading: isLoadingLeadSourceRate,
        refetch: refetechLeadSourceRate,
    } = useQuery<any[]>({
        queryKey: ["dashboard/lead_source_rate/"],
        queryFn: () => customFetcher({ endpoint: `/dashboard/lead_source_rate/` }),
    });
    return { leadSourceRateArray, isLoadingLeadSourceRate, refetch: refetechLeadSourceRate };
};
